import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDelete = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	id: "delete_icon",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#delete_a)",
		children: /* @__PURE__ */ _jsx("path", { d: "M20.485 3.534a12.003 12.003 0 0 0-16.97 16.98 12.136 12.136 0 0 0 16.684.277 12.1 12.1 0 0 0 2.47-3.26 12 12 0 0 0 1.2-3.744q.13-.877.13-1.763a11.93 11.93 0 0 0-3.514-8.49M5.292 5.292a9.62 9.62 0 0 1 12.23-1.023.264.264 0 0 1 .03.4L4.668 17.561a.265.265 0 0 1-.4-.031A9.5 9.5 0 0 1 5.292 5.292m13.457 13.464a9.52 9.52 0 0 1-12.231 1.023.264.264 0 0 1-.032-.4L19.373 6.486a.265.265 0 0 1 .4.031 9.5 9.5 0 0 1-1.023 12.239z" })
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "delete_a",
		children: /* @__PURE__ */ _jsx("path", { d: "M0 0h24v24H0z" })
	}) })]
});
export { SvgDelete as ReactComponent };
